import { sel } from '../utils'
import './cardBlurVar.css'

// gsap.registerPlugin(ScrollTrigger)
export default function CardBlur() {
  const testimonials$ = sel('.exec-card')

  if (!testimonials$) return
  console.log('Init testimonial slider')

  const ua = navigator.userAgent
  const isSafari = /Safari\//.test(ua) && !/Chrome\//.test(ua) && !/Chromium\//.test(ua)
  if (isSafari) {
    testimonials$.style.setProperty('--card-blur', '0px')
    return
  }

  // ===== Utilities =====
  const rootFont = () => parseFloat(getComputedStyle(document.documentElement).fontSize)
  const toPx = (len, base = rootFont()) => {
    if (typeof len === 'number') return len
    const v = String(len).trim()
    if (v.endsWith('rem')) return parseFloat(v) * base
    if (v.endsWith('px')) return parseFloat(v)
    return parseFloat(v) || 0 // fallback assumes px
  }
  const clamp = (n, min, max) => Math.max(min, Math.min(max, n))
  const setAttr = (el, name, val) => el.setAttribute(name, String(val))
  const prec = (n) => Number(n.toFixed(6))

  const maskW$ = sel('.svg-mask defs')
  const mask$ = maskW$?.sel('#cutout')
  // const hole = document.querySelector('#cutout-1 #hole')
  if (!mask$) return

  const section = ['exec-stats-sec']
  const item = '.exec-card'
  let maskCounter = 0

  section.forEach((sec, sectionIdx) => {
    const section$ = sel(`.${sec}`)
    const item$a = section$?.selAll(item)
    if (!item$a || item$a.length === 0) return

    item$a.forEach((item$, itemIdx) => {
      const info$a = item$.selAll('.exec-card__lo')
      if (!info$a || info$a.length === 0) return

      info$a.forEach((info$, infoIdx) => {
        maskCounter++

        // Clone the mask and hole for this specific info$ element
        const newMask$ = mask$.cloneNode(true)
        const newHole$ = newMask$.sel('#hole')
        const maskId = `cutout-var-${maskCounter}`
        const holeId = `hole-var-${maskCounter}`
        newMask$.setAttribute('id', maskId)
        newHole$.setAttribute('id', holeId)

        maskW$.appendChild(newMask$)

        const hole = sel(`#${maskId} #${holeId}`)

        // Apply the mask to the info$ element's ::before pseudo element via CSS custom property
        info$.style.setProperty('--mask-url', `url(#${maskId})`)

        function updateMaskFractions() {
          if (!item$ || !info$ || !hole) return
          const { width: W, height: H } = item$.getBoundingClientRect()
          const infoBounds = info$.getBoundingClientRect()
          const itemBounds = item$.getBoundingClientRect()

          if (!W || !H) return

          const cs = getComputedStyle(item$)
          const infoCs = getComputedStyle(info$)

          // Get X padding (same for left and right)
          const insetX = toPx(cs.getPropertyValue('--inset-x'))

          // Get different top and bottom Y values from info$ element
          const insetYTop = toPx(infoCs.getPropertyValue('--inset-y-top'))
          const insetYBottom = toPx(infoCs.getPropertyValue('--inset-y-bottom'))

          const radius = toPx(cs.getPropertyValue('--radius'))

          // Calculate position relative to the card
          const relativeTop = infoBounds.top - itemBounds.top
          const relativeBottom = itemBounds.bottom - infoBounds.bottom

          // Convert to 0..1 fractions for objectBoundingBox coords
          const xFrac = clamp(insetX / W, 0, 0.4999)
          const yFrac = clamp((relativeTop + insetYTop) / H, 0, 0.4999)
          const wFrac = clamp(1 - 2 * xFrac, 0, 1)

          // Height calculation with different top and bottom insets
          const holeTop = relativeTop + insetYTop
          const holeBottom = H - relativeBottom - insetYBottom
          const hFrac = clamp((holeBottom - holeTop) / H, 0, 1)

          // Keep corners visually circular after non-uniform scaling
          let rxFrac = radius / W
          let ryFrac = radius / H
          rxFrac = Math.min(rxFrac, wFrac / 2)
          ryFrac = Math.min(ryFrac, hFrac / 2)

          // Write fractions to the mask rect
          setAttr(hole, 'x', prec(xFrac))
          setAttr(hole, 'y', prec(yFrac))
          setAttr(hole, 'width', prec(wFrac))
          setAttr(hole, 'height', prec(hFrac))
          setAttr(hole, 'rx', prec(rxFrac))
          setAttr(hole, 'ry', prec(ryFrac))
        }

        // Run now and on resize / font load (rem changes)
        const ro = new ResizeObserver(updateMaskFractions)
        ro.observe(item$)
        ro.observe(info$)
        window.addEventListener('resize', updateMaskFractions, { passive: true })
        if (document.fonts?.ready) document.fonts.ready.then(updateMaskFractions)
        updateMaskFractions()
      })
    })
  })
}
